import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path:  process.env.VUE_APP_BASE_URL,
    component: () => import('../views/main'),
    children: [
      {
        path: '/mail-list',
        component: () => import('../views/userinfo/mail-list')
      },
      // 开票公司
      {
        path: '/invoice-company-list',
        component: () => import('../views/invoice/company/invoice-company-list')
      },
      {
        path: '/invoice-company-detail',
        component: () => import('../views/invoice/company/invoice-company-detail')
      },
      // 发票内容
      {
        path: '/invoice-content-list',
        component: () => import('../views/invoice/content/invoice-content-list')
      },
      {
        path: '/invoice-content-detail',
        component: () => import('../views/invoice/content/invoice-content-detail')
      },
      //发票信息管理
      {
        path: '/invoice-infomanage-detail',
        component: () => import('../views/invoice/content/invoice-infomanage-detail')
      },
      {
        path: '/invoice-infomanage-list',
        component: () => import('../views/invoice/content/invoice-infomanage-list'),
        meta: {
          keepAlive: true
        }
      },
      // 提成方案
      {
        path: '/royalty-plan-list',
        component: () => import('../views/royalty-plan/royalty-plan-list')
      },
      {
        path: '/add-royalty-plan',
        component: () => import('../views/royalty-plan/add-royalty-plan'),
        meta:{
          key:'royaltyPlan',
          isStep:true,
          active:1
        },
      },
      {
        path: '/add-royalty-plan-second',
        component: () => import('../views/royalty-plan/add-royalty-plan-second')
      },
      {
        path: '/royalty-plan-detail',
        component: () => import('../views/royalty-plan/royalty-plan-detail'),
        meta:{
          key:'royaltyPlan',
          isStep:true,
          active:2
        },
      },
      {
        path: '/royalty-plan-success',
        component: () => import('../views/royalty-plan/royalty-plan-success'),
        meta:{
          key:'royaltyPlan',
          isStep:true,
          active:3
        },
      },

      //开票管理
      {
        path: '/invoice-manage-list',
        component: () => import('../views/invoice-manage/invoice-manage-list'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/invoice-manage-detail',
        component: () => import('../views/invoice-manage/invoice-manage-detail')
      },
      {
        path: '/invoice-manage-add',
        component: () => import('../views/invoice-manage/invoice-manage-add')
      },
      //税收管理
      {
        path: '/tax-category-list',
        component: () => import('../views/tax-category/tax-category-list')
      },
      {
        path: '/tax-category-detail',
        component: () => import('../views/tax-category/tax-category-detail')
      },
      //待开票列表
      {
        path: '/to-beInvoiced-list',
        component: () => import('../views/to-beInvoiced/to-beInvoiced-list')
      },
      {
        path: '/to-beInvoiced-detail',
        component: () => import('../views/to-beInvoiced/to-beInvoiced-detail')
      },

      // 集采提成方案
      {
        path: '/purchase-plan-list',
        component: () => import('../views/purchase-plan/purchase-plan-list')
      },
      {
        path: '/add-purchase-plan',
        component: () => import('../views/purchase-plan/add-purchase-plan')
      },
      {
        path: '/purchase-plan-detail',
        component: () => import('../views/purchase-plan/purchase-plan-detail')
      },
      //回款查询
      {
        path: '/payment-inquiry-list',
        component: () => import('../views/payment-inquiry/payment-inquiry-list'),
        meta: {
          keepAlive: true
        }
      },
      //回款查询
      {
        path: '/payment-inquiry-order',
        component: () => import('../views/payment-inquiry/payment-inquiry-order')
      },
      //核销单列表
      {
        path: '/verification-orders-list',
        component: () => import('../views/payment-inquiry/verification-orders-list'),
        meta: {
          keepAlive: true
        }
      },
      //核销单详情
      {
        path: '/verification-orders-detail',
        component: () => import('../views/payment-inquiry/verification-orders-detail')
      },
       //数据核查
      {
        path: '/check-orders-list',
        component: () => import('../views/payment-inquiry/check-orders-list')
      },
      // 积分方案
      {
        path: '/points-plan-list',
        component: () => import('../views/points-plan/points-plan-list')
      },
      {
        path: '/add-points-plan',
        component: () => import('../views/points-plan/add-points-plan'),
        meta:{
          key:'pointsPlan',
          isStep:true,
          active:1
        },
      },
      {
        path: '/points-plan-detail',
        component: () => import('../views/points-plan/points-plan-detail'),
        meta:{
          key:'pointsPlan',
          isStep:true,
          active:2
        },
      },
      {
        path: '/points-plan-success',
        component: () => import('../views/points-plan/points-plan-success'),
        meta:{
          key:'pointsPlan',
          isStep:true,
          active:3
        },
      },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
